import type { WorkspaceListItem } from "./api";

export function workspaceInitial(name: string): string {
  return name.trim().charAt(0).toLocaleUpperCase() || "C";
}

export function workspaceStatus(workspace: WorkspaceListItem): string {
  return `${workspaceArtifactLabel(workspace)} · ${workspaceStatusLabel(workspace)}`;
}

export function workspaceArtifactLabel(workspace: WorkspaceListItem): string {
  return workspace.artifact.kind === "website" ? "Website" : "iPhone app";
}

export function workspaceStatusLabel(workspace: WorkspaceListItem): string {
  if (workspace.artifact.kind === "website") {
    return workspace.artifact.status === "live" ? "Live" : "Draft";
  }
  if (workspace.artifact.status === "testing") return "TestFlight";
  return workspace.artifact.status === "live" ? "App Store" : "Draft";
}

export function workspaceDestination(workspace: WorkspaceListItem): string {
  if (workspace.artifact.kind === "ios_app") {
    return workspace.previewUrl ? "iPhone preview" : "iPhone preview not ready";
  }
  if (!workspace.previewUrl) return "Preview not ready";
  try {
    return new URL(workspace.previewUrl).host;
  } catch {
    return workspace.id;
  }
}

export function workspaceActivityLabel(
  lastActivityAt: string | undefined,
  now = new Date(),
): string {
  if (!lastActivityAt) return "No activity yet";
  const activity = new Date(lastActivityAt);
  if (Number.isNaN(activity.getTime())) return "No activity yet";
  const elapsedMs = Math.max(0, now.getTime() - activity.getTime());
  const elapsedMinutes = Math.floor(elapsedMs / 60_000);
  if (elapsedMinutes < 1) return "Updated just now";
  if (elapsedMinutes < 60) return `Updated ${elapsedMinutes}m ago`;
  const elapsedHours = Math.floor(elapsedMinutes / 60);
  if (elapsedHours < 24) return `Updated ${elapsedHours}h ago`;
  const elapsedDays = Math.floor(elapsedHours / 24);
  if (elapsedDays < 7) return `Updated ${elapsedDays}d ago`;
  const options: Intl.DateTimeFormatOptions = {
    month: "short",
    day: "numeric",
    ...(activity.getFullYear() === now.getFullYear()
      ? {}
      : { year: "numeric" }),
  };
  return `Updated ${new Intl.DateTimeFormat("en-US", options).format(activity)}`;
}
